import { nanoid } from "nanoid";
function sendBeacon(urlString) {
  try {
    const url = new URL(urlString);
    url.searchParams.set(nanoid(), Date.now().toString());
    const img = document.createElement("img");
    img.src = url.toString();
    img.style.display = "none";
    img.addEventListener("load", () => {
      var _a;
      (_a = img == null ? void 0 : img.remove) == null ? void 0 : _a.call(img);
    });
    img.addEventListener("error", () => {
      var _a;
      (_a = img == null ? void 0 : img.remove) == null ? void 0 : _a.call(img);
    });
    document.body.appendChild(img);
  } catch (err) {
    console.error("Error occurred while sending beacon", err, urlString);
  }
}
export {
  sendBeacon
};
